export default [
	{
		path: '/calendar/content/onboarding',
		name: 'Schedule Content Onboarding',
		component: () => import('@/views/calendar/ScheduleContentOnboarding.vue'),
		meta: {
			layout: 'Default',
			abilities:[[ 'view', 'workspace-content'], ['manage', 'workspace-content']]
		}
	},
/* 	{
		path: '/calendar/campaign',
		name: 'Campaign Calendar',
		component: () => import('@/views/calendar/CampaignCalendar.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'campaigns'], ['manage', 'campaigns']]
		}
	},
	{
		path: '/calendar/campaign1',
		name: 'Campaign Calendar V1',
		component: () => import('@/views/calendar/CampaignCalendarV1.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'campaigns'], ['manage', 'campaigns']]
		}
	},
	{
		path: '/calendar/campaign2',
		name: 'Campaign Calendar V2',
		component: () => import('@/views/calendar/CampaignCalendarV2.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'campaigns'], ['manage', 'campaigns']]
		}
	}, */
]
